import { Suspense, lazy, useMemo } from "react";
import { jsx } from "react/jsx-runtime";
import { SuspenseFallback } from "@tecnobit-srl/components-store";
//#region src/use-courses-reviews.tsx
var LazyCoursesReviews = lazy(() => import("./courses-reviews-6G5GNyUS.js").then((n) => n.n).then((module) => ({ default: module.CoursesReviews })));
function CoursesReviews({ ...props }) {
	return /* @__PURE__ */ jsx(Suspense, {
		fallback: /* @__PURE__ */ jsx(SuspenseFallback, { name: "courses-reviews" }),
		children: /* @__PURE__ */ jsx(LazyCoursesReviews, { ...props })
	});
}
function CoursesReviewsContent({ ...props }) {
	return /* @__PURE__ */ jsx(Suspense, {
		fallback: /* @__PURE__ */ jsx(SuspenseFallback, { name: "courses-reviews" }),
		children: /* @__PURE__ */ jsx(LazyCoursesReviews, { ...props })
	});
}
var useCoursesReviewsContent = () => {
	return useMemo(() => ({ coursesReviews: { component: CoursesReviewsContent } }), []);
};
//#endregion
export { CoursesReviews, useCoursesReviewsContent };
